module.exports = __webpack_public_path__ + "static/media/showevent_content_TAOS_2018.7001cf87.jpg";